import { render } from "./ApprovalDetail.vue?vue&type=template&id=c254f39e&scoped=true"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js"

import "./ApprovalDetail.vue?vue&type=style&index=0&id=c254f39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c254f39e"]])

export default __exports__